module.exports = __webpack_public_path__ + "media/images/hapier/conceito_hapier_3-8cf3972229491f308f3f8e2fd078ab46.png";